// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

import { createBrowserRouter } from 'react-router';

import { getPath } from '@helsenorge/framework-utils/hn-page';

import { RootComponent } from './root/RootComponent';

const router = createBrowserRouter(
  [
    {
      path: '/*',
      element: <RootComponent />,
    },
  ],
  { basename: `/${getPath()}` }
);

export default router;
